module.exports = __webpack_public_path__ + "media/images/workplace/star_icons-a05fc57a0fe489b759b9dd8bca27a777.png";